'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import Client from 'AdsUI/data/Client';
import { getContactsStatus, EntityTypes } from 'AdsUI/lib/Constants';

const getBodyFromUpdate = (_ref) => {
  let {
    status
  } = _ref,
      update = _objectWithoutPropertiesLoose(_ref, ["status"]);

  return Object.assign({
    entityStatus: status && getContactsStatus(status)
  }, update);
};

export const getAdWordsCampaignTargetingCriteria = (adAccountId, campaignId) => {
  return Client.apiRequest(`ads/v1/entity/manage/adwords/${adAccountId}/campaign/${campaignId}/targeting`);
};
export const getAdWordsAdGroupTargetingCriteria = (adAccountId, campaignId, adGroupId) => {
  return Client.apiRequest(`ads/v1/entity/manage/adwords/${adAccountId}/campaign/${campaignId}/adgroup/${adGroupId}/targeting`);
};
export const updateCampaign = opts => {
  const {
    accountId,
    id,
    network,
    update
  } = opts;
  return Client.apiRequest(`ads/v1/entity/manage/${network.toLowerCase()}/${accountId}/campaign/${id}`, {
    type: 'PUT',
    data: getBodyFromUpdate(update)
  });
};
export const updateAdGroup = opts => {
  const {
    accountId,
    campaignId,
    id,
    network,
    update
  } = opts;
  return Client.apiRequest(`ads/v1/entity/manage/${network.toLowerCase()}/${accountId}/campaign/${campaignId}/adgroup/${id}`, {
    type: 'PUT',
    data: getBodyFromUpdate(update)
  });
};
export const updateAd = opts => {
  const {
    accountId,
    adGroupId,
    campaignId,
    id,
    network,
    update
  } = opts;
  return Client.apiRequest(`ads/v1/entity/manage/${network.toLowerCase()}/${accountId}/campaign/${campaignId}/adgroup/${adGroupId}/ad/${id}`, {
    type: 'PUT',
    data: getBodyFromUpdate(update)
  });
};
export const updateKeyword = opts => {
  const {
    accountId,
    adGroupId,
    campaignId,
    id,
    network,
    update
  } = opts;
  return Client.apiRequest(`ads/v1/entity/manage/${network.toLowerCase()}/${accountId}/campaign/${campaignId}/adgroup/${adGroupId}/keyword/${id}`, {
    type: 'PUT',
    data: getBodyFromUpdate(update)
  });
};
export const createKeyword = ({
  adAccountId,
  campaignId,
  adGroupId,
  keywordText,
  matchType
}) => {
  return Client.apiRequest('ads/v1/creation/adwords/keywords', {
    type: 'POST',
    data: {
      adAccountId,
      campaignId,
      adGroupId,
      keywordText,
      matchType
    }
  });
};
export const createKeywords = (adAccountId, campaignId, adGroupId, keywords) => {
  return Client.apiRequest('ads/v1/creation/adwords/keywords/bulk', {
    type: 'POST',
    data: {
      adAccountId,
      campaignId,
      adGroupId,
      keywords
    }
  });
};
export const deleteKeyword = ({
  network,
  adAccountId,
  campaignId,
  adGroupId,
  keywordId
}) => {
  return Client.apiRequest(`ads/v1/entity/manage/${network}/${adAccountId}/campaign/${campaignId}/adgroup/${adGroupId}/keyword/${keywordId}`, {
    type: 'DELETE'
  });
};
export const deleteAdGroup = ({
  network,
  adAccountId,
  campaignId,
  adGroupId
}) => {
  return Client.apiRequest(`ads/v1/entity/manage/${network}/${adAccountId}/campaign/${campaignId}/adgroup/${adGroupId}`, {
    type: 'DELETE'
  });
};
export const getPages = (adNetwork, adAccountId) => {
  return Client.apiRequest(`ads/v1/entity/manage/${adNetwork.toLowerCase()}/${adAccountId}/pages`);
};
export const getCampaignBudget = (adNetwork, adAccountId, campaignId) => {
  return Client.apiRequest(`ads/v1/entity/manage/${adNetwork.toLowerCase()}/${adAccountId}/campaign/${campaignId}/budget`);
};
export const FETCH_TARGETING_CRITERIA_BY_ENTITY_TYPE = {
  [EntityTypes.CAMPAIGN]: (adAccount, campaignEntity, __adGroupEntity) => getAdWordsCampaignTargetingCriteria(adAccount.accountId, campaignEntity.id),
  [EntityTypes.ADGROUP]: (adAccount, campaignEntity, adGroupEntity) => getAdWordsAdGroupTargetingCriteria(adAccount.accountId, campaignEntity.id, adGroupEntity.id)
};